import React from 'react';
import './Card.css';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Card({ product, isCompany, isActive, onClick }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!product) return null;

  const firstLetter = ((product.posterDisplayName || product.posterEmail || '?')[0]).toUpperCase();
  const posterName = product.posterDisplayName || product.posterEmail?.split('@')[0] || t('card.unknown');
  const productPath = (!isCompany && product.id) ? `/product/${product.id}` : (isCompany && product.id ? `/company/${product.id}` : null);

  const handleAction = (event) => {
    if (event) event.stopPropagation();
    if (productPath) {
      navigate(productPath);
    }
  };

  const handleCardKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleAction();
    }
  };

  return (
    <div
      className={`product-card ${isActive ? 'active-company-card' : ''} ${isCompany ? 'company-card-horizontal' : ''}`}
      role="button"
      tabIndex={0}
      onClick={handleAction}
      onKeyDown={handleCardKeyDown}
    >
      <div className="card-image-container">
        {product.category && (
          <div className="card-badge">{product.category}</div>
        )}
        <Link to={productPath || '#'} onClick={(event) => event.stopPropagation()}>
          {product.images && product.images.length > 0 ? (
            <img src={product.images[0]} alt={product.name} className="card-image" />
          ) : (
            <div className="card-no-image">
              <span>{t('card.noImage')}</span>
            </div>
          )}
        </Link>
        {isCompany && (
          <button className="card-view-menu-btn" onClick={handleAction} type="button">
            {t('card.viewMenu')}
          </button>
        )}
      </div>
      
      <div className="card-content">
        <div className="card-header">
          <h3 className="card-name">
            {isCompany ? (
              <span className="card-title-link">{product.name || t('card.unnamedProduct')}</span>
            ) : (
              <Link to={productPath || '#'} className="card-title-link" onClick={(event) => event.stopPropagation()}>
                {product.name || t('card.unnamedProduct')}
              </Link>
            )}
          </h3>
          {!isCompany && (
            <span className="card-price">${product.finalPrice != null ? Number(product.finalPrice).toFixed(2) : '0.00'}</span>
          )}
        </div>
        
        <p className="card-desc">{product.description || t('card.noDescription')}</p>
        
        <div className="card-footer">
          <div className="card-poster">
            <div className="card-avatar">
              {firstLetter}
            </div>
            <span>{posterName}</span>
          </div>
          
          {!isCompany && (
            <span className="card-action">
              <button
                className="card-btn"
                onClick={handleAction}
                type="button"
              >
                {t('card.orderNow')}
              </button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default Card;
